import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRocket,
  faLaptopCode,
  faMobileAlt,
  faShoppingCart,
  faCogs,
  faServer,
  faGlobe,
  faPaintBrush,
  faWallet,
  faMobileScreen,
  faCloudArrowUp,
  faDatabase,
} from '@fortawesome/free-solid-svg-icons';

interface RenderServicePlanProps {
  title: string;
  subtitle: string;
  details: string[];
}

const getIcon = (subtitle: string) => {
  if (/start|business/i.test(subtitle)) return faRocket;
  if (/rebuild|website|upgrade/i.test(subtitle)) return faLaptopCode;
  if (/mobile/i.test(subtitle)) return faMobileAlt;
  if (/ecom/i.test(subtitle)) return faShoppingCart;
  return faRocket;
};

const getFeatureIcon = (text: string) => {
  if (/server/i.test(text)) return faServer;
  if (/consult/i.test(text)) return faCogs;
  if (/gateway/i.test(text)) return faWallet;
  if (/design|prototype/i.test(text)) return faPaintBrush;
  if (/database/i.test(text)) return faDatabase;
  if (/front/i.test(text)) return faGlobe;
  if (/back/i.test(text)) return faCloudArrowUp;
  if (/mobile/i.test(text)) return faMobileScreen;
  return faCogs;
};

export const RenderServicePlan = ({ title, subtitle, details }: RenderServicePlanProps) => {
  const icon = getIcon(subtitle);

  return (
    <div className="relative mt-8 mx-auto max-w-xs w-full" data-aos="zoom-in-up">
      {/* Phone shell */}
      <div className="bg-black rounded-[2.5rem] border-4 border-xencode-gold shadow-[0_0_30px_rgba(255,215,0,0.2)] overflow-hidden relative aspect-[9/16]">
        {/* Notch */}
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-1.5 bg-gray-700 rounded-full opacity-50 z-10" />

        {/* Phone content */}
        <div className="relative z-10 h-full w-full flex flex-col bg-gradient-to-br from-xencode-black via-[#0f0f0f] to-xencode-contact-black text-white p-4 pt-10">
          {/* Header */}
          <div className="text-center mb-4">
            <FontAwesomeIcon icon={icon} className="text-3xl text-xencode-gold mb-2" />
            <h2 className="text-lg font-bold uppercase text-xencode-gold tracking-wider">
              {title}
            </h2>
            <p className="text-xs italic text-gray-400">{subtitle}</p>
          </div>

          {/* Divider */}
          <div className="h-[1px] bg-xencode-gold/20 mb-4" />

          {/* App feature grid */}
          <div className="grid grid-cols-2 gap-3 flex-1 overflow-y-auto px-1 scrollbar-thin scrollbar-thumb-xencode-gold/40 scrollbar-track-transparent">
            {details.map((detail, index) => (
              <div
                key={index}
                className="bg-xencode-black/50 border border-xencode-gold/10 rounded-xl px-3 py-4 flex flex-col items-center justify-center text-center hover:bg-xencode-gold/10 transition active:scale-95 cursor-pointer"
              >
                <FontAwesomeIcon
                  icon={getFeatureIcon(detail)}
                  className="text-xencode-gold text-lg mb-2"
                />
                <p className="text-[0.7rem] leading-snug text-white">{detail}</p>
              </div>
            ))}
          </div>

          {/* Home bar */}
          <div className="mt-4 flex justify-center">
            <div className="w-16 h-1.5 bg-gray-600 rounded-full opacity-30" />
          </div>
        </div>
      </div>
    </div>
  );
};
